import React, { useState, useEffect } from "react";

export function CookieConsent() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    if (!localStorage.getItem("qs_cookie_consent")) setShow(true);
  }, []);
  if (!show) return null;
  const decide = (v) => {
    localStorage.setItem("qs_cookie_consent", v);
    setShow(false);
  };
  return (
    <div
      data-testid="cookie-consent"
      className="fixed bottom-4 inset-x-4 md:left-auto md:right-6 md:max-w-md z-[60] qs-glass rounded-xl border border-white/10 p-5"
    >
      <p className="text-sm text-white font-semibold mb-1">Privacy-conscious analytics</p>
      <p className="text-xs text-[#94A3B8] leading-relaxed mb-4">
        We use privacy-conscious analytics to understand usage. You can accept or decline non-essential tracking.
      </p>
      <div className="flex gap-2">
        <button
          onClick={() => decide("accepted")}
          data-testid="cookie-accept"
          className="flex-1 px-3 py-2 text-xs font-semibold rounded-full bg-[#2DD4BF] text-[#030305] hover:bg-white transition-colors"
        >
          Accept
        </button>
        <button
          onClick={() => decide("declined")}
          data-testid="cookie-decline"
          className="flex-1 px-3 py-2 text-xs rounded-full border border-white/15 text-white hover:bg-white/5 transition-colors"
        >
          Decline
        </button>
      </div>
    </div>
  );
}
